import { render, staticRenderFns } from "./FirearmsAddEdit.vue?vue&type=template&id=18c4792a&"
import script from "./FirearmsAddEdit.vue?vue&type=script&lang=ts&"
export * from "./FirearmsAddEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports